@if (data) {
  <div id="notification-event-preferences">
    <h2>{{eventName}}</h2>
    <mat-divider></mat-divider>
    <div>
      <div>Select</div>
      <div>Email</div>
      <div>In - App</div>
      <div>Push</div>
      <div>SMS</div>
    </div>
    <div>
      <div>
        <mat-checkbox id="selector-box" [disabled]="isBoxDisabled" (change)="boxChanged($event)"></mat-checkbox>
      </div>
      <div>
        <mat-checkbox [disabled]="isBoxDisabled" [(ngModel)]="data.isEmailSubscribed" (change)="boxChanged($event)"></mat-checkbox>
      </div>
      <div>
        <mat-checkbox [disabled]="isBoxDisabled" [(ngModel)]="data.isInAppSubscribed" (change)="boxChanged($event)"></mat-checkbox>
      </div>
      <div>
        <mat-checkbox [disabled]="isBoxDisabled" [(ngModel)]="data.isPushSubscribed" (change)="boxChanged($event)"></mat-checkbox>
      </div>
      <div>
        <mat-checkbox [disabled]="isBoxDisabled" [(ngModel)]="data.isSmsSubscribed" (change)="boxChanged($event)"></mat-checkbox>
      </div>
    </div>
    <div>
      <button mat-raised-button (click)="save()">Save</button>
    </div>
  </div>
}
